module.exports = __webpack_public_path__ + "img/User.2e24c519.svg";